import { friendlyImpactTitle } from '@upright/common/utils';
import { valenceColor } from '@upright/ui/common/generic/utilities/format';
import { zeroWidthNonBreakingSpace } from '@upright/ui/common/generic/utilities/zero-width-space';
import { InfoBoxBottomPart } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-bottom-part';
import { InfoBoxLikeButton } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-like-button';
import { InfoBoxLinkButton } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-link-button';
import { InfoBoxQuoteText } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-quote-text';
import { InfoBoxStepper } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-stepper';
import { InfoBoxTitleRow } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-title-row';
import { InsightOrTargetQuote } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { ThreePartInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/three-part-info-box';
import { ImpactInsight } from '@upright/ui/common/upright/core/impact-lenses/insights/common/types';
import { useState } from 'react';
import styled from 'styled-components';

interface Props {
  id: string;
  insights: ImpactInsight[];
  x: number;
  y: number;
  width: number;
  height: number;
}

export function NarrativeInfoBox(props: Props) {
  const items = props.insights.sort(d => d.order || 0); // Lowest order will be shown first
  const [index, setIndex] = useState(0);
  const item = items[index];
  const { text, link } = item;

  return (
    <ThreePartInfoBox
      width={props.width}
      height={props.height}
      x={props.x}
      y={props.y}
      id={props.id}
      minHeight={props.height}
      contentTop={
        <>
          <ColorBlock style={{ backgroundColor: valenceColor(props.insights[0].valence) }}>
            {zeroWidthNonBreakingSpace}
          </ColorBlock>
          <InfoBoxTitleRow>
            <div>Insights on {friendlyImpactTitle(item.impactCategoryId)}</div>
          </InfoBoxTitleRow>
        </>
      }
      contentMiddle={
        <>
          <InsightOrTargetQuote>
            <div>
              <InfoBoxQuoteText>{text}</InfoBoxQuoteText>
            </div>
          </InsightOrTargetQuote>
        </>
      }
      contentBottom={
        <>
          <InfoBoxBottomPart
            left={
              <>
                <InfoBoxLikeButton
                  companyId={item.companyId}
                  clientDataType={item.clientDataType}
                  clientDataId={item.id}
                  likes={item.likes}
                  liked={item.liked}
                />
                {link && <InfoBoxLinkButton href={link} />}
              </>
            }
            right={<InfoBoxStepper total={items.length} setIndex={setIndex} index={index} />}
          />
        </>
      }
    />
  );
}

const ColorBlock = styled.div`
  height: 2px;
`;
